<template>
  <div>
    <el-card>
      <el-button v-loading="isLoading" @click="getLog" type="primary" class="ml-16">
        查詢
      </el-button>
    </el-card>
    <enhanced-table
      :table-data="filteredLogList"
      :col-configs="colConfigs"
      :is-loading="isLoading"
      :table-options="{ size: 'mini', stripe: true }"
      :page-size="20"
    >
      <template v-slot:header>
        <div class="log-filter">
          <span class="log-filter__label">Log Type</span>
          <el-select
            v-model="selectedLogType"
            size="small"
            filterable
            placeholder="全部"
          >
            <el-option
              v-for="item in logTypeOptions"
              :key="item.value || 'all'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </template>
      <template v-slot:client_id="{ colConfig }">
        <el-table-column v-bind="colConfig" label="用戶">
          <template v-slot="{ row }">
            <template v-if="row.client_id">
              <div>{{ row.client_id.name || '（無名稱）' }}</div>
              <div style="font-size:12px; color:#909399;">{{ row.client_id.email }}</div>
            </template>
            <span v-else style="color:#c0c4cc;">（系統）</span>
          </template>
        </el-table-column>
      </template>
    </enhanced-table>
  </div>
</template>

<script>
import moment from 'moment';
import EnhancedTable from '@/components/common/EnhancedTable';

export default {
  components: {
    EnhancedTable,
  },
  data() {
    return {
      isLoading: false,
      logList: [],
      colConfigs: [
        {
          label: '時間',
          prop: 'created_at',
          formatter(row, column, cellValue) {
            return moment(cellValue).format('YYYY-MM-DD HH:mm');
          },
          'min-width': '150px',
        },
        {
          slot: 'client_id',
          sortable: true,
          'min-width': '220px',
        },
        {
          label: '類型',
          prop: 'type',
          formatter(row, column, cellValue) {
            const typeMap = {
              add_log: '新增',
              delete_log: '刪除',
              update_log: '更新',
              view_log: '查看',
              unauthorized_view_log: '無驗證外部 API 查看',
              xml_log: 'XML 輸出查詢',
              line_api_log: 'LINE API 呼叫',
              login_log: '登入',
              loginFailed_log: '登入失敗',
              login_initialCredential_log: '使用初始密碼登入',
              login_lockedAttempt_log: '鎖定中嘗試登入',
              login_accountLocked_log: '帳戶被鎖定',
            };
            return typeMap[cellValue] || cellValue;
          },
          'min-width': '120px',
        },
        {
          label: 'IP',
          prop: 'ip',
          formatter(row, column, cellValue) {
            return cellValue || '-';
          },
          'min-width': '140px',
        },
        {
          label: '耗時 (ms)',
          prop: 'duration',
          formatter(row, column, cellValue) {
            return cellValue != null ? cellValue : '-';
          },
          'min-width': '90px',
        },
        {
          label: '內容',
          prop: 'message',
          'min-width': '400px',
        },
      ],
      selectedLogType: '',
      logTypeOptions: [
        { label: '全部', value: '' },
        { label: '新增操作', value: 'add_log' },
        { label: '刪除操作', value: 'delete_log' },
        { label: '更新操作', value: 'update_log' },
        { label: '查看操作（需登入）', value: 'view_log' },
        { label: '無驗證的外部 API 查看', value: 'unauthorized_view_log' },
        { label: 'XML 輸出查詢', value: 'xml_log' },
        { label: 'LINE API 呼叫', value: 'line_api_log' },
        { label: '登入成功', value: 'login_log' },
        { label: '登入失敗', value: 'loginFailed_log' },
        { label: '使用初始密碼嘗試登入', value: 'login_initialCredential_log' },
        { label: '帳戶鎖定中仍嘗試登入', value: 'login_lockedAttempt_log' },
        { label: '失敗次數過多，帳戶被鎖定', value: 'login_accountLocked_log' },
      ],
    };
  },
  computed: {
    filteredLogList() {
      if (!this.selectedLogType) {
        return this.logList;
      }
      return this.logList.filter(log => log.type === this.selectedLogType);
    },
  },
  methods: {
    getLog() {
      this.isLoading = true;
      return this.$axios({
        category: 'admin',
        method: 'get',
        apiName: 'log',
      })
        .then(res => {
          this.logList = res.data;
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  padding: 2px 0;
}
::v-deep .el-table .cell {
  padding: 0 8px;
  line-height: 1.4;
}
.log-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}
.log-filter__label {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
}
</style>
